import { takeLatest, put, call } from 'redux-saga/effects';
import {
    FETCH_SORTED_PARTNER_LIST_REQUEST, fetchSortedPartnerListResponse, ALLOCATE_PARTNER_DATA_TO_SERVER_REQUEST,
    allocatePartnerDataToServerResponse, FETCH_ALLOCATED_PARTNER_DATA_REQUEST, fetchAllocatedPartnerDataResponse,
    SEARCH_COUNTERPARTY_REQUEST, searchCounterpartyResponse, FETCH_ALLOCATED_SEARCH_COUNTERPARTY_REQUEST,
    FETCH_PARTNER_PRODUCT_LIST_REQUEST, fetchPartnerProductListResponse, FETCH_PARTNER_ORDER_DATA_REQUEST, fetchPartnerOrderDataResponse,
    UPDATE_ADDITIONAL_DETAILS_REQUEST, upadateAdditinalDetailsResponse, REALLOCATE_PARTNER_DATA_SERVER_REQUEST, reallocatePartnerResponse
} from './action';
import { REPORT } from '../../../../config';
import { HTTP_HEADERS } from '../../../../constants'
import request from "../../../../components/Utils/httpHelper";

export function* fetchSortedPartnerListRequest(action) {
    let requestURL = `${REPORT}/partnerpreference/sortedPartnerList/${action.data.countryCode}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchSortedPartnerListResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchSortedPartnerListResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* fetchSortedPartnerListData() {
    yield takeLatest(FETCH_SORTED_PARTNER_LIST_REQUEST, fetchSortedPartnerListRequest);
}

export function* allocatePartnerDataToServerRequest(action) {
    let requestURL = `${REPORT}/v1/international/allocateCase`;
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(allocatePartnerDataToServerResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(allocatePartnerDataToServerResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* allocatePartnerData() {
    yield takeLatest(ALLOCATE_PARTNER_DATA_TO_SERVER_REQUEST, allocatePartnerDataToServerRequest);
}

export function* fetchAllocatedPartnerDataRequest(action) {
    let requestURL = `${REPORT}/partnerreportrequest/partnerCase/${action.data.caseId}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchAllocatedPartnerDataResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchAllocatedPartnerDataResponse({ ...err.data, status: "FAILURE" }))
    }
}

export function* fetchAllocatedPartnerData() {
    yield takeLatest(FETCH_ALLOCATED_PARTNER_DATA_REQUEST, fetchAllocatedPartnerDataRequest);
}

export function* searchCounterpartyRequest(action) {
    let requestURL = `${REPORT}/v1/international/search/collated`;
    try {
        const params = { counterpartyName: action.data.counterpartyName, countryCode: action.data.countryCode };
        if (action.data.partnerId) {
            params.partnerId = action.data.partnerId;
        }
        const data = yield call(request, requestURL, { method: 'GET', params, headers: HTTP_HEADERS });
        yield put(searchCounterpartyResponse({ data: data.data.results.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(searchCounterpartyResponse({ ...err.data, status: "FAILURE" }))
    }
}

export function* searchCounterpartyData() {
    yield takeLatest(SEARCH_COUNTERPARTY_REQUEST, searchCounterpartyRequest);
}

export function* fetchAllocatedSearchDataRequest(action) {
    let requestURL = `${REPORT}/v1/international/search/allocated/${action.data.caseId}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(searchCounterpartyResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(searchCounterpartyResponse({ ...err.data, status: "FAILURE" }))
    }
}

export function* fetchAllocatedSearchData() {
    yield takeLatest(FETCH_ALLOCATED_SEARCH_COUNTERPARTY_REQUEST, fetchAllocatedSearchDataRequest);
}

export function* fetchPartnerProductListRequest(action) {
    let requestURL = `${REPORT}/partnerendpoint/endpoints/${action.data.partnerId}/${action.data.productType}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchPartnerProductListResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchPartnerProductListResponse({ ...err.data, status: "FAILURE" }))
    }
}

export function* fetchPartnerProductList() {
    yield takeLatest(FETCH_PARTNER_PRODUCT_LIST_REQUEST, fetchPartnerProductListRequest);
}

export function* fetchPartnerOrderDataRequest(action) {
    let requestURL = `${REPORT}/v1/international/partnerOrderData/${action.data.caseId}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchPartnerOrderDataResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(fetchPartnerOrderDataResponse({ ...err.data, status: "FAILURE" }))
    }
}

export function* fetchPartnerOrderData() {
    yield takeLatest(FETCH_PARTNER_ORDER_DATA_REQUEST, fetchPartnerOrderDataRequest);
}

export function* updateAdditionalDetailsRequest(action) {
    let requestURL = `${REPORT}/case/updateAdditionalDetails`;
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(upadateAdditinalDetailsResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(upadateAdditinalDetailsResponse({ ...err.data, status: "FAILURE" }))
    }
}

export function* updateAdditionalDetails() {
    yield takeLatest(UPDATE_ADDITIONAL_DETAILS_REQUEST, updateAdditionalDetailsRequest);
}

export function* reallocatePartnerRequest(action) {
    let requestURL = `${REPORT}/v1/international/reallocate/${action.data.caseId}`;
    try {
        const data = yield call(request, requestURL, { method: 'POST', headers: HTTP_HEADERS });
        yield put(reallocatePartnerResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(reallocatePartnerResponse({ ...err.data, status: "FAILURE" }))
    }
}

export function* reallocatePartnerData() {
    yield takeLatest(REALLOCATE_PARTNER_DATA_SERVER_REQUEST, reallocatePartnerRequest);
}